export default __webpack_public_path__ + "static/media/aleksandr_kalinyuk.ed47430d.jpg";